import React from "react";

const AccountEnabled = props => {
  let squareClass = "";
  let iconClass = "";
  let tooltipText = "";

  // Determine if the account is enabled or disabled
  const isDisabled = props.enableuser === "Inactive";
  const isOnline = props.isOnline;

  // Set tooltip and icon based on status
  if (isDisabled) {
    iconClass = "fa fa-close";
    tooltipText = "Inactive";
  } else {
    iconClass = "fa fa-check";
    tooltipText = "Active";
  }

  // Check online status
  if (isOnline) {
    squareClass = "fa fa-square text-success";
    tooltipText += " - Online";
  } else {
    squareClass = "fa fa-square text-secondary";
    tooltipText += " - Offline";
  }

  return (
    <span title={tooltipText} className="fa-stack">
      <i className={squareClass + " fa-stack-1x"} aria-hidden="true" />
      <i className={iconClass + " fa-stack-1x fa-inverse"} aria-hidden="true" style={{ fontSize: '0.70em' }} />
    </span>
  );
};

export default AccountEnabled;